'use client';

import {ServiceLayout} from "@/app/_components/ServiceLayout";
import {ServiceHeader} from "@/app/_components/ServiceHeader";
import styles from "./index.module.scss";
import {questions, servicesData} from "./data";
import Alert from "@/app/_components/Shared/Alert";
import Faq from "@/app/_components/Shared/Faq";
import Image from "next/image";
import AdminServiceImage from "@/app/images/admin-service.jpg";
import AdminServiceMobileImage from "@/app/images/admin-service-mobile.jpg";
import MobileImage from "@/app/images/mobile.png";
import Services from "@/app/_components/Shared/Services";
import {useRouter} from "nextjs-toploader/app";

export default function AdminService() {
    const router = useRouter();

    const handleStartNow = () => {
        router.push('/pro-services-request');
    };
    return (
        <ServiceLayout>
            <ServiceHeader
                className={styles.serviceHeaderImage}
                image={<><Image className={styles.serviceHeaderImage} src={AdminServiceImage} alt="service"/><Image className={styles.serviceHeaderMobileImage} src={AdminServiceMobileImage} alt="service"/></>}
                title="Fastest PRO Services in the UAE – Only with Ninjaz."
                buttonLink={"/pro-services-request"}
                buttonText={"Request PRO Services"}
            />
            <p>
                Experience the fastest, most transparent PRO services in the UAE with Ninjaz. AI-driven, tech-enabled
                solutions for all your visa, license, and government liaison needs.
            </p>
            <p>
                Managing administrative tasks and government relations in the UAE is no easy feat. With multiple
                ministries, regulations, and requirements, it can quickly become overwhelming. But
                with <strong>Ninjaz</strong>, the process is faster, simpler, and more transparent than ever.
            </p>
            <p>
                We offer a full range of PRO services, from <strong>trade license management</strong> and <strong>visa
                processing</strong> to <strong>government liaison</strong> across all departments. Powered by our
                proprietary tech platform, we ensure that your business stays compliant while you focus on what
                matters—growing your business.
            </p>
            <h2 className={styles.subheading}>
                Service Details
            </h2>
            <Services data={servicesData} />
            <h1 className={styles.title}>
                Who Needs Our PRO Services?
            </h1>
            <p>
                Our PRO services are perfect for businesses that:
            </p>
            <p>
                - Have multiple employees or departments requiring regular administrative tasks<br></br>
                - Need support managing visa services (employment, investor, dependent)<br></br>
                - Require frequent interactions with various UAE ministries (Ministry of Labor, Ministry of Economy,
                Ministry of Justice, etc.)<br></br>
                - Must handle numerous transactions related to trade licenses, establishment cards, and more<br></br>
                - Face random administrative requests and need a partner to track and manage them effectively<br></br>
            </p>
            <Image className={styles.fullImage} src={MobileImage} alt="mobile" />
            <Alert buttonText="Request PRO Services" buttonOnClick={handleStartNow}>
                Ready to start your Journey?
            </Alert>
            <Faq data={questions}/>
        </ServiceLayout>
    );
}
